import serviceData from './serviceData'

export default (registration: ServiceWorkerRegistration): void => {
  console.log('versionUtils.onSuccess called.', registration)
  serviceData.setServiceWorkerRegistration(registration)
}
